import { c as _c } from "react/compiler-runtime";
import { Outlet } from 'react-router-dom';
import { TunnelProvider } from './context';
const TunnelWithContext = () => {
    const $ = _c(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = <TunnelProvider>
      <Outlet />
    </TunnelProvider>;
        $[0] = t0;
    }
    else {
        t0 = $[0];
    }
    return t0;
};
export default TunnelWithContext;
